import { components } from '@kurtosys/ksys-app-components';

import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';
import { megaMenuStyle } from '../styles/MegaMenu.styles.js';

const Label = components.base.Label.Label;

export default InjectedStyledComponent(
	Label,
	'megaMenu',
	['buttonLabel'],
	undefined,
	undefined,
	undefined,
	megaMenuStyle,
);
